module.exports = __webpack_public_path__ + "static/media/radio.4a741ca5.svg";